import { render, staticRenderFns } from "./InviteStatus.vue?vue&type=template&id=630c1fe4&scoped=true"
import script from "./InviteStatus.vue?vue&type=script&lang=js"
export * from "./InviteStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630c1fe4",
  null
  
)

export default component.exports